import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {

  connect() {
    // console.log("Hello, Bootstrap activation!", this.element);

    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {  
      return new bootstrap.Popover(popoverTriggerEl)  
    })

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    // Tabs met Buttons
    const triggerTabListButtons = document.querySelectorAll('.nav-tabs button');
    triggerTabListButtons.forEach(function (triggerEl) {
      const tabTrigger = new bootstrap.Tab(triggerEl)

      triggerEl.addEventListener('click', function (event) {
        event.preventDefault()
        tabTrigger.show()
      })
    })

    // Tabs met Links
    const triggerTabListLinks= document.querySelectorAll('.nav-tabs a');
    triggerTabListLinks.forEach(function (triggerEl) {
      const tabTrigger = new bootstrap.Tab(triggerEl)

      triggerEl.addEventListener('click', function (event) {
        tabTrigger.show()
      })
    })
    
  }
}
